import React, {FC} from 'react';
import cn from 'classnames';
import {LocationPoint} from '@/common/interfaces/location';
import {LocationLink} from '@/app/components/common/LocationLink';
import styles from './MapLocationsList.css';

interface MapLocationsListProps {
	columns: number;
	locations: LocationPoint[];
}

export const MapLocationsList: FC<MapLocationsListProps> = props => {
	const {columns, locations} = props;

	const itemsPerColumn = Math.ceil(locations.length / columns);

	// TODO use css columns
	return (
		<div className={styles.root} role='list'>
			{new Array(columns).fill(null).map((value, index) => (
				// eslint-disable-next-line react/no-array-index-key
				<div key={index} className={styles.column}>
					{locations.slice(index * itemsPerColumn, index * itemsPerColumn + itemsPerColumn).map(location => (
						<div key={location.id} className={styles.item} role='listitem'>
							<LocationLink
								className={cn(styles.link, location.flags.countryAdminCenter && styles.isMarked)}
								location={location}
							/>
						</div>
					))}
				</div>
			))}
		</div>
	);
};

MapLocationsList.displayName = 'MapLocationsList';
